/* eslint-disable @typescript-eslint/no-explicit-any */
import { Cookie } from '@repo/tools'
import type { UserGetOtcPriceParams, UserOtcGetHistoryParams } from '../api'
import userOtcService from './user-otc.service'
import { EUserOtcQueryKey } from './user-otc.types'

export const getOtcPriceOptions = (filter: UserGetOtcPriceParams) => {
  return {
    queryKey: [EUserOtcQueryKey.GET_OTC_PRICE, filter],
    queryFn: () => userOtcService.getOtcPrice(filter),
    enabled:
      !!filter.symbol && filter.symbol !== '' && !!Cookie.get('access_token'),
  }
}
export const getOtcHistoryOptions = (filter: UserOtcGetHistoryParams) => {
  return {
    queryKey: [EUserOtcQueryKey.GET_OTC_HISTORY, filter],
    queryFn: () => userOtcService.otcGetHistory(filter),
  }
}

export const getOtcHistoryInfiniteOptions = (
  params: UserOtcGetHistoryParams,
) => {
  return {
    queryKey: [EUserOtcQueryKey.GET_OTC_HISTORY, params],

    queryFn: ({ pageParam = 0 }) =>
      userOtcService.otcGetHistory({
        ...params,
        skip: pageParam * (params.limit || 10),
      }),
    staleTime: 1,
    getNextPageParam: (lastPage: any, allPages: any) => {
      const total = lastPage.data?.total

      const transactions = lastPage.data?.transactions || []
      const limit = params.limit || 10

      // If we have total count, use it for pagination
      if (total !== undefined && total !== null) {
        const currentLength = allPages.reduce(
          (acc: number, page: any) =>
            acc + (page.data?.transactions?.length || 0),
          0,
        )
        return currentLength < total ? allPages.length : undefined
      }

      // Fallback: If no total, check if we got fewer messages than requested
      // This indicates we've reached the end
      if (transactions.length < limit) {
        return undefined
      }

      // If we got exactly the limit, there might be more data
      return allPages.length
    },
    initialPageParam: 0,
  }
}
